






import Vue from "vue";
import JzContainer from "./JzContainer.vue";

interface Props {
  count?: number;
  title: string;
}

export default Vue.extend<{}, {}, {}, Props>({
  name: "JzTab",
  components: { JzContainer },
  props: {
    count: { type: Number, default: 0 },
    title: { type: String, required: true }
  }
});
